import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid, FormControlLabel, Switch } from '@mui/material';
import { withRights } from 'providers/RightsConsumer';

const OfferAssetFirstOwnerComponent = React.memo(({ t, rights, onPropertyChange, firstOwner, selfPartnerName, processing }) => {
  const changeFirstOwnerValue = event => {
    let propertyValue;
    if (event.target.checked === true) propertyValue = '1';
    else propertyValue = '0';
    onPropertyChange('firstOwner', propertyValue);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} md={4}>
        <FormControlLabel
          control={
            <Switch
              id={'offerAssetCard_firstOwner'}
              checked={
                firstOwner &&
                (firstOwner === '1' ||
                  firstOwner.toLowerCase() === 'true' ||
                  firstOwner.toLowerCase() === 'da' ||
                  firstOwner.toLowerCase() === 'yes')
                  ? true
                  : false
              }
              onChange={changeFirstOwnerValue}
              disabled={rights.readOnlyFull || !rights.financedAssetWrite || processing}
            />
          }
          label={selfPartnerName + ' ' + t('OfferEdit.Asset.Info.FirstOwner')}
        />
      </Grid>
    </Grid>
  );
});

OfferAssetFirstOwnerComponent.displayName = 'OfferAssetFirstOwnerComponent';

OfferAssetFirstOwnerComponent.propTypes = {
  t: PropTypes.func.isRequired,
  rights: PropTypes.object.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  maxMonths: PropTypes.number,
  firstOwner: PropTypes.bool,
  selfPartnerName: PropTypes.string,
  processing: PropTypes.bool
};

export default withTranslation()(withRights(OfferAssetFirstOwnerComponent));
